import ViewableMetadata from './ViewableMetadata';

export default ViewableMetadata;
